












































import Item from './item.vue'
import StyleSelect from '../../../components/common/styleselect.vue'

DATA_MIXIN = {
  data: ->
    onLoadPage: false
    page: 1
    perPage: 8
    inFeedbacksFilterValues: [
      { value: 'all', label: 'Все' }
      { value: 'in', label: 'Добавленные' }
      { value: 'not_in', label: 'Не добавленные' }
    ]
    inFeedbacksFilter: 'all'
}

export default {
  name: 'ExpertFeedbacksModerationMain'

  mixins: [DATA_MIXIN]

  components: { Item, StyleSelect }

  methods:
    onClick: ({ id, context }) ->
      feedback = @expertFeedbacks.find (x) -> parseInt(x.id) == parseInt(id)
      return unless !!feedback
      feedback.in_feedbacks = context == 'add'

    onPageChange: (page) ->
      return if @onLoadPage
      @onLoadPage = true
      @page = parseInt(page)
      @retrieveData({ page: @page })

    retrieveData: (_params = {}) ->
      params = _params
      Object.assign(params, { in_feedbacks: @inFeedbacksFilter }) if @inFeedbacksFilter != 'all'
      $.ajax({
        url: @indexPath,
        method: 'GET',
        dataType: 'json',
        data: params,
        success: @onRetrieveDataSuccess
      })

    onRetrieveDataSuccess: (data) ->
      @expertFeedbacks = data.expert_feedbacks
      @expertFeedbacksCount = data.expert_feedbacks_count
      @onLoadPage = false

  watch:
    inFeedbacksFilter: (n, o) ->
      @onPageChange(1) if !!n && n != o

  computed:
    emptyText: ->
      @$i18n('pages.system.idea_groups.empty_list')

    calcPagesCount: ->
      Math.ceil(parseInt(@expertFeedbacksCount) / parseInt(@perPage))

    numberPage:
      get: ->
        parseInt(@page)
      set: (v) ->
        @page = parseInt(v)
}
